import React from "react";
import {observer} from "mobx-react";
import {
    ILowFareResult,
    LowFareStatusEnum
} from "../../../../services/low-fare/low-fare-readers/low-fare-reader.interface";
import {UnavailableDayComponent} from "./days/unavailable-day.component";
import {DaySpinnerComponent} from "./days/day-spinner.component";
import {SameDayComponent} from "./days/same-day.component";
import {SelectedDayComponent} from "./days/selected-day.component";
import {RegularDayComponent} from "./days/regular-day.component";
import {DayCellBox} from "./days/boxes/day-cell.box";
import styled from "styled-components";
import {DayPricesNotShowComponent} from "./days/day-prices-not-show.component";
import {
    FlightsDatesSelectorModel
} from "../../../../services/flight-search/dates-selection/flights-dates-selector.model";
import {
    FlightScheduleAvailabilityStatusEnum,
    IFlightDateScheduleAvailability
} from "../../../../services/flights-schedule/flights-schedule.service.interface";


const FlightDayContainerBox = styled(DayCellBox)`
    padding: 0;
    align-items: center;
`

interface FlightDayComponentProps {
    date: Date;
    captureSelectedDateElementRef?: (date: Date, element: HTMLElement | null) => void;
    flightsDatesSelector: FlightsDatesSelectorModel;
}

export const FlightDayComponent: React.FC<FlightDayComponentProps> = observer((props) => {

    const isSelected = props.flightsDatesSelector.isDateSelected(props.date);

    const captureDayContentBoxElement = (el: any) => {
        if(isSelected && props.captureSelectedDateElementRef) {
            props.captureSelectedDateElementRef(props.date, el);
        }
    }

    let currentLowFareResult: ILowFareResult = {
        status: LowFareStatusEnum.NoFare
    };



    let dayAvailability: IFlightDateScheduleAvailability = props.flightsDatesSelector.getDateAvailability(props.date);

    const renderPriceNotShown = () => {
        return (
            <FlightDayContainerBox ref={captureDayContentBoxElement}>
                <DayPricesNotShowComponent date={props.date} flightsDatesSelector={props.flightsDatesSelector}/>
            </FlightDayContainerBox>
        );
    }

    currentLowFareResult = props.flightsDatesSelector.getLowFare(props.date);

    if(currentLowFareResult.status === LowFareStatusEnum.Disabled) {
        return renderPriceNotShown();
    }


    const renderDay = () => {
        if(dayAvailability.status === FlightScheduleAvailabilityStatusEnum.Reading || currentLowFareResult.status === LowFareStatusEnum.Reading) {
            return (
                <DaySpinnerComponent/>
            );
        }



        if(props.flightsDatesSelector.isSameDateForDepartureAndReturn(props.date)) {
            return (
                <SameDayComponent date={props.date} flightsDatesSelector={props.flightsDatesSelector}/>
            )
        }

        if(isSelected) {
            return (
                <SelectedDayComponent date={props.date}
                                      flightsDatesSelector={props.flightsDatesSelector}/>
            );
        }

        if(dayAvailability.status !== FlightScheduleAvailabilityStatusEnum.Available) {
            return (
                <UnavailableDayComponent date={props.date}
                                         flightsDatesSelector={props.flightsDatesSelector}
                                         isSoldOut={dayAvailability.status === FlightScheduleAvailabilityStatusEnum.SoldOut}/>
            )
        }

        return (
            <RegularDayComponent date={props.date} flightsDatesSelector={props.flightsDatesSelector} />
        )

    }

    return (
        <FlightDayContainerBox ref={captureDayContentBoxElement}>
            {renderDay()}
        </FlightDayContainerBox>
    );
})
